import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { MapGeocoder } from '@angular/google-maps';

@Injectable({
  providedIn: "root"
})
export class GeolocationService {
  sendLocationAdress = new Subject();

  constructor(private geocoder: MapGeocoder) { }

  geocodeLatLong(position) {



    const latlng = {

      lat: parseFloat(position.coords.latitude.toString()),
      lng: parseFloat(position.coords.longitude.toString())
    };
    this.geocoder.geocode({ location: latlng }).subscribe((response) => {
      if (response.status === "OK") {

        // this.geocoder.geocode({ placeId: response.results[0].place_id }).subscribe((placeResponse) => {

        // })
        const address = `${response.results[0].address_components[0].short_name} ` +
        `${response.results[0].address_components[1].short_name}, ` +
        `${response.results[0].address_components[3].long_name}`;

      this.sendLocationAdress.next(address);
      }
    });
  }
}
